const FakeStore = {
    token: null,

    sessions: []
};

export default FakeStore;
